import { MONTHS_IN_YEAR } from '@/shared/constants/common';
import { PaymentInterval } from '@/shared/types/Billing';

import { getProductPrice } from './getProductPrice';

type GetFormattedPlanPrice = {
  paymentInterval: PaymentInterval | undefined;
  price: number;
};

export const getFormattedPlanPrice = ({ paymentInterval, price }: GetFormattedPlanPrice) => {
  const { annual, monthly } = getProductPrice(price);

  const formattedYearPrice = price % MONTHS_IN_YEAR ? Number.parseFloat(annual.toFixed(2)) : annual;
  const isYearInterval = paymentInterval === PaymentInterval.Year;

  const prettified = Math.ceil(isYearInterval ? formattedYearPrice : monthly);

  return prettified;
};
